<template>
  <div class="service tooltip-target b3">
    <v-popover>
      <p class="name">{{service.name}}</p>
      <template slot="popover">
        <a class="detail-close" v-close-popover>X</a>
        <ServiceDetail
          v-bind:service="service"
        />
        
      </template>
    </v-popover>

    <p class="version" @click="changeServiceVersion(instanceIndex, instanceUrl, serviceIndex, service.url, service.version)">{{service.version}}</p>
    <p class="url"><a target="_blank" :href="service.url">{{service.url}}</a></p>
  </div>

</template>

<script>
import ServiceDetail from '@/components/ServiceDetail.vue'
export default {
  props: {
    service: {
      type: Object,
      requierd: true  
    },
    instanceIndex: Number,
    instanceUrl: String,
    serviceIndex: Number
  },
  components: {
    ServiceDetail
  },
  methods: {
    changeServiceVersion(instanceIndex, instanceUrl, serviceIndex, serviceUrl, serivceVersion) {
      const data = {type: "service", instanceIndex: instanceIndex, instanceUrl: instanceUrl, serviceIndex: serviceIndex, serviceUrl: serviceUrl, inputText: serivceVersion}
      this.$root.$refs.App_component.openModal(data);
    }
  }
}
</script>

<style>
  
  .service {
    position: relative;
    float: left;
    width: 250px;
    border: 1px solid #ccc;
    margin: 5px;
    -webkit-box-shadow: 4px 4px 10px -6px rgba(66, 68, 90, 1);
    -moz-box-shadow: 4px 4px 10px -6px rgba(66, 68, 90, 1);
    box-shadow: 4px 4px 10px -6px rgba(66, 68, 90, 1);
    transition: box-shadow 0.2s;
  }
  .service:hover {
    box-shadow: 5px 5px 13px -4px rgba(66, 68, 90, 1);
  }
  .service .name {
    font-weight: bold;
    font-size: 16px;
  }
  .service .name, .version, .url {
    width: 100%;
  }
  .detail-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 0px 5px;
    cursor: pointer;
    font-weight: bold;
    color: #4787ff;
    background: transparent;
  }

.tooltip {

  &.popover {
    $color: #f9f9f9;

    .popover-inner {
      background: $color;
      color: black;
      padding: 24px;
      border-radius: 5px;
      -webkit-box-shadow: 0px 0px 31px -14px rgba(66, 68, 90, 1);
      -moz-box-shadow: 0px 0px 31px -14px rgba(66, 68, 90, 1);
      box-shadow: 0px 0px 31px -14px rgba(66, 68, 90, 1);
    }

    .popover-arrow {
      border-color: $color;
    }
  }
}

.popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 15px;
  border-radius: 5px;
  -webkit-box-shadow: 4px 4px 34px -6px rgba(66, 68, 90, 1);
  -moz-box-shadow: 4px 4px 34px -6px rgba(66, 68, 90, 1);
  box-shadow: 4px 4px 34px -6px rgba(66, 68, 90, 1);
}

.popover-arrow {
  border-color: #f9f9f9;
}
</style>